module.exports = __webpack_public_path__ + "static/img/miss-you.a28d4529.svg";